
// Getter Object for ArtistsCatalog. Use it by calling mapGetters from the Vuex Host Components.

import { state } from "../../../../../scripts/blueprints/module/store/state";

export const artistsCatalogGetters = {
  artistsCatalogData: (state) => state.artistsCatalogData,
  artistsList:(state)=>state.artistsList,
  startRow:(state)=>state.startRow,
  artistDetails:(state)=>state.artistDetails
}


